// Added by Joey S @ Shopify Theme Support | 22 October 2026
(function () {
  'use strict';
  if (window.ThemeSupportPickup) { window.ThemeSupportPickup.init(document); return; }
  var mounted = new Set();
  function pad(n) { return String(n).padStart(2, '0'); }
  function iso(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function parseDate(v) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(v || '');
    if (!m) return null;
    var d = new Date(+m[1], +m[2] - 1, +m[3]);
    return d.getFullYear() === +m[1] && d.getMonth() === +m[2] - 1 && d.getDate() === +m[3] ? d : null;
  }
  function timeList(v) {
    return Array.from(new Set((v || '').split(/[\s,]+/).filter(function (s) { return /^(?:[01]\d|2[0-3]):[0-5]\d$/.test(s); }))).sort();
  }
  function mount(root) {
    if (root._pickup) return;
    var date = root.querySelector('[data-pickup-date]'), time = root.querySelector('[data-pickup-time]');
    var dateMirror = root.querySelector('[data-pickup-date-mirror]'), timeMirror = root.querySelector('[data-pickup-time-mirror]');
    var open = root.querySelector('[data-pickup-open]'), clear = root.querySelector('[data-pickup-clear]');
    var message = root.querySelector('[data-pickup-message]'), form = document.getElementById(root.dataset.form);
    var days = (root.dataset.openDays || '').split(',').filter(Boolean).map(Number);
    var holidays = (root.dataset.holidays || '').split(/[\s,]+/).filter(parseDate);
    var sameDay = root.dataset.sameDay === 'true', cutoff = sameDay && root.dataset.cutoffEnabled === 'true';
    var cutoffHour = Number(root.dataset.cutoffHour), zone = (root.dataset.timezone || '').trim();
    var clock, picker, limits, timer, destroyed = false, bypass = false, submitting = false;
    var pending = Promise.resolve(), sequence = 0, dirty = false, lastSaved = null;
    function tell(text) { message.textContent = text || ''; }
    function values() { var a = {}; a[root.dataset.dateKey] = date.value; a[root.dataset.timeKey] = time.value; return a; }
    function mirror() {
      dateMirror.value = date.value; timeMirror.value = time.value;
      clear.disabled = !date.value && !time.value;
      dirty = JSON.stringify(values()) !== lastSaved;
    }
    function range() {
      var now = new Date(), today, hour;
      if (clock) {
        var p = {}; clock.formatToParts(now).forEach(function (part) { p[part.type] = part.value; });
        today = new Date(+p.year, +p.month - 1, +p.day); hour = +p.hour % 24;
      } else { today = new Date(now.getFullYear(), now.getMonth(), now.getDate()); hour = now.getHours(); }
      var min = new Date(today);
      if (!sameDay || (cutoff && hour >= cutoffHour)) min.setDate(min.getDate() + 1);
      var last = new Date(today.getFullYear(), today.getMonth() + 3, 0).getDate();
      return { min: min, max: new Date(today.getFullYear(), today.getMonth() + 2, Math.min(today.getDate(), last)) };
    }
    function available(v) {
      var d = parseDate(v), r = range();
      return !!d && v >= iso(r.min) && v <= iso(r.max) && days.indexOf(d.getDay()) >= 0 && holidays.indexOf(v) < 0;
    }
    function save(success) {
      mirror();
      var id = ++sequence, attributes = values(), snapshot = JSON.stringify(attributes);
      tell(root.dataset.saving);
      pending = pending.then(function () {
        if (destroyed || id !== sequence) return;
        var abort = new AbortController(), timeout = setTimeout(function () { abort.abort(); }, 8000);
        return fetch(root.dataset.updateUrl, {
          method: 'POST', credentials: 'same-origin', signal: abort.signal,
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: attributes })
        }).then(function (response) {
          if (!response.ok) throw new Error('Pickup autosave failed (' + response.status + ')');
          lastSaved = snapshot; mirror();
          if (id === sequence && !destroyed) tell(success || root.dataset.saved);
        }).catch(function () {
          if (id === sequence && !destroyed) tell(root.dataset.saveError);
        }).finally(function () { clearTimeout(timeout); });
      });
      return pending;
    }
    function enhance() {
      if (!picker) return;
      picker.calendarContainer.querySelectorAll('.ts-pickup-day').forEach(function (day) {
        day.setAttribute('role', 'button');
        day.setAttribute('aria-disabled', day.classList.contains('is-disabled') ? 'true' : 'false');
        day.setAttribute('aria-pressed', day.classList.contains('is-selected') ? 'true' : 'false');
        day.dataset.pickupIso = iso(day.dateObj);
      });
      [[picker.prevMonthNav, root.dataset.previousMonth], [picker.nextMonthNav, root.dataset.nextMonth]].forEach(function (pair) {
        pair[0].setAttribute('role', 'button'); pair[0].setAttribute('tabindex', '0'); pair[0].setAttribute('aria-label', pair[1]);
        pair[0].setAttribute('aria-disabled', pair[0].classList.contains('is-disabled') ? 'true' : 'false');
      });
    }
    function refresh() {
      if (!picker || destroyed) return;
      var next = range(), old = date.value;
      if (iso(limits.min) !== iso(next.min) || iso(limits.max) !== iso(next.max)) {
        limits = next; picker.set({ minDate: limits.min, maxDate: limits.max });
      }
      if (old && !available(old)) { picker.clear(false); date.value = ''; save(root.dataset.unavailable); }
      enhance();
    }
    function visibility() { if (!document.hidden) refresh(); }
    function syncTheme() {
      if (!picker) return;
      var style = getComputedStyle(root);
      ['background', 'foreground', 'accent', 'accent-text', 'font'].forEach(function (name) {
        var value = style.getPropertyValue('--ts-pickup-' + name);
        if (value) picker.calendarContainer.style.setProperty('--ts-pickup-' + name, value);
      });
    }
    function onSubmit(event) {
      if (bypass || destroyed) return;
      refresh(); mirror();
      if (!dirty && sequence === 0) return;
      event.preventDefault();
      if (submitting) return;
      submitting = true;
      var submitter = event.submitter;
      (dirty ? save() : pending).finally(function () {
        if (destroyed || !form.isConnected) return;
        // A fulfilled promise can run while the browser is still dispatching the
        // first submit event. Resume in a new task, not a re-entrant microtask.
        setTimeout(function () {
          if (destroyed || !form.isConnected) return;
          mirror(); bypass = true; submitting = false;
          try { form.requestSubmit(submitter && submitter.isConnected ? submitter : undefined); }
          finally { bypass = false; }
        }, 0);
      });
    }
    try {
      if (!form || !window.PickupCalendarEngine) throw new Error('Pickup calendar or cart form is missing');
      if (cutoff && (!zone || !Number.isInteger(cutoffHour) || cutoffHour < 0 || cutoffHour > 23)) throw new Error('Pickup cutoff needs a timezone and valid hour');
      if (zone) clock = new Intl.DateTimeFormat('en-CA', { timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' });
      limits = range();
      var times = timeList(root.dataset.times), initialTime = time.value, initialDate = date.value;
      if ((root.dataset.times || '').trim() && !times.length) throw new Error('No valid configured pickup times');
      if (times.length) {
        var select = document.createElement('select'); select.id = time.id; select.className = time.className;
        select.setAttribute('data-pickup-time', ''); select.setAttribute('aria-describedby', time.getAttribute('aria-describedby'));
        select.add(new Option(root.dataset.chooseTime, ''));
        times.forEach(function (v) { select.add(new Option(v, v)); });
        select.value = times.indexOf(initialTime) >= 0 ? initialTime : '';
        time.replaceWith(select); time = select;
      }
      if (date.value && !available(date.value)) date.value = '';
      var locale = document.documentElement.lang || 'en';
      function names(kind, count, style) {
        var f = new Intl.DateTimeFormat(locale, Object.assign({ timeZone: 'UTC' }, kind === 'weekday' ? { weekday: style } : { month: style }));
        return Array.from({ length: count }, function (_, i) { return f.format(new Date(Date.UTC(2024, kind === 'weekday' ? 0 : i, kind === 'weekday' ? 7 + i : 1))); });
      }
      picker = window.PickupCalendarEngine(date, {
        minDate: limits.min, maxDate: limits.max,
        disable: [function (d) { return days.indexOf(d.getDay()) < 0 || holidays.indexOf(iso(d)) >= 0; }],
        locale: { weekdays: { shorthand: names('weekday', 7, 'short'), longhand: names('weekday', 7, 'long') }, months: { shorthand: names('month', 12, 'short'), longhand: names('month', 12, 'long') }, yearAriaLabel: root.dataset.yearLabel, monthAriaLabel: root.dataset.monthLabel, scrollTitle: '', toggleTitle: '' },
        onOpen: function () {
          refresh(); syncTheme(); open.setAttribute('aria-expanded', 'true'); date.setAttribute('aria-expanded', 'true');
          var day = picker.selectedDateElem || picker.calendarContainer.querySelector('.ts-pickup-day:not(.is-disabled):not(.prevMonthDay):not(.nextMonthDay)');
          if (day) day.focus();
        },
        onClose: function () { open.setAttribute('aria-expanded', 'false'); date.setAttribute('aria-expanded', 'false'); },
        onMonthChange: enhance, onYearChange: enhance,
        onChange: function () { save(); enhance(); }
      });
      var calendar = picker.calendarContainer;
      calendar.classList.add('ts-pickup-calendar');
      calendar.setAttribute('role', 'dialog'); calendar.setAttribute('aria-label', root.dataset.calendarLabel);
      date.setAttribute('aria-controls', calendar.id); open.setAttribute('aria-controls', calendar.id);
      syncTheme();
      var close = document.createElement('button'); close.type = 'button'; close.className = 'ts-pickup-calendar__close'; close.textContent = root.dataset.closeCalendar; picker.addFooter(close);
      close.addEventListener('click', function () { picker.close(); open.focus(); });
      calendar.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); picker.close(); open.focus(); }
        else if ((e.key === 'Enter' || e.key === ' ') && (e.target === picker.prevMonthNav || e.target === picker.nextMonthNav)) {
          e.preventDefault(); e.stopPropagation(); if (e.target.getAttribute('aria-disabled') !== 'true') picker.changeMonth(e.target === picker.prevMonthNav ? -1 : 1);
        }
      }, true);
      open.addEventListener('click', function () { picker.open(); });
      clear.addEventListener('click', function () { picker.clear(false); date.value = ''; time.value = ''; save(); });
      time.addEventListener('input', mirror); time.addEventListener('change', function () { save(); });
      form.addEventListener('submit', onSubmit);
      document.addEventListener('visibilitychange', visibility); timer = setInterval(refresh, 30000);
      date.disabled = false; time.disabled = false; open.disabled = false;
      lastSaved = JSON.stringify((function () { var v = {}; v[root.dataset.dateKey] = initialDate; v[root.dataset.timeKey] = initialTime; return v; })());
      mirror(); enhance();
      root._pickup = { picker: picker, refresh: refresh, available: available, settled: function () { return pending; }, destroy: function () {
        destroyed = true; clearInterval(timer); document.removeEventListener('visibilitychange', visibility); form.removeEventListener('submit', onSubmit);
        picker.destroy(); mounted.delete(root); delete root._pickup;
      } };
      mounted.add(root);
      if (date.value !== initialDate || time.value !== initialTime) save(root.dataset.unavailable);
    } catch (error) {
      if (picker) picker.destroy(); clearInterval(timer);
      date.disabled = true; time.disabled = true; open.disabled = true; clear.disabled = true;
      tell(root.dataset.configError);
    }
  }
  function init(scope) {
    if (scope.matches && scope.matches('[data-ts-pickup]')) mount(scope);
    scope.querySelectorAll('[data-ts-pickup]').forEach(mount);
  }
  window.ThemeSupportPickup = { init: init, version: '0.4.0-jquery-ui' };
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { mounted.forEach(function (root) { if (e.target === root || e.target.contains(root)) root._pickup.destroy(); }); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
})();
// End of Added Code
